import { useStaticQuery, graphql } from 'gatsby'
import { mapCraft } from './mappings'

const query = graphql`
{
  craft {
    entry(section: contact) {
      ...on Craft_Contact {
        title
        masthead {
          heading
          image {
            title
            url
          }
          backgroundColor
        }
        businessEnquiries: contactBusinessEnquiries {
          body {
            content
          }
          image {
            title
            url
          }
        }
        metadata {
          ...metadataFields
        }
      }
    }
    globals {
      companyDetails {
        contactEmail
        contactNumber
        officeAddress
      }
    }
  }
}
`

export const useCraft = () => {
  const { craft } = useStaticQuery(query)
  return mapCraft(craft)
}
